export const WhoisMapper = {
  hydrate: ({ refer, whois, country, role, continent }) => ({
    refer: typeof refer === 'string' ? refer : 'whois.ripe.net',
    whois: typeof whois === 'string' ? whois : 'whois.ripe.net',
    country: typeof country === 'string' ? country : 'ES',
    role: typeof role === 'string' ? role : 'Tecnicos Telefonica de España',
    continent: typeof continent === 'string' ? continent : 'Europe',
  }),
};
